<!--
 * @Description: 德育考评、全校-年级-班级统计展示列表
 * @Author: 烟雨
 * @Date: 2022-03-21 9:26:30
 * @LastEditors: 烟雨
 * @LastEditTime: 2022-04-12 18:21:59
-->
<template>
  <div class="evaluation">
    <!-- 汇总信息 -->
    <div class="bg-FFFFFF p-0-16 pb-16">
      <div class="pb-8 font-30 ff-medium text-bold-500" v-if="evaluationTitle">
        {{ evaluationTitle }}
      </div>
      <div
        class="fb fb-cross-center fb-main-between"
        v-if="computedEvaluationList.length"
      >
        <div
          class="item-flex-1 bg-F6F6F6 p-0-12 pb-6 item-self-stretch bd-radio-8"
          @click="handleToRecords(1)"
        >
          <div class="fb fb-cross-center p-10-0">
            <span class="dot bg-006AFE bd-radio-2"></span>
            <p class="font-24 c-171A1D-60 ff-regular">表扬</p>
          </div>
          <div class="font-60 ff-ding-condensed-bold break-all">
            {{ +totalEvaluationMap.totalPraiseScore > 0 ? '+' : ''
            }}{{ totalEvaluationMap.totalPraiseScore }}
          </div>
        </div>
        <div
          class="ml-16 item-flex-1 bg-F6F6F6 p-0-12 pb-6 item-self-stretch bd-radio-8"
          @click="handleToRecords(2)"
        >
          <div class="fb fb-cross-center p-10-0">
            <span class="dot bg-FF9200 bd-radio-2"></span>
            <p class="font-24 c-171A1D-60 ff-regular">待改进</p>
          </div>
          <div class="font-60 ff-ding-condensed-bold break-all">
            {{ totalEvaluationMap.totalNeedImproveScore }}
          </div>
        </div>
      </div>
    </div>

    <template v-if="computedEvaluationList.length">
      <!-- 列表展示信息 -->
      <div
        class="bg-F6F6F6 p-0-16 hidden"
        v-if="+type === 1 || +type === 2"
        key="more"
      >
        <div
          class="list-card bg-FFFFFF bd-radio-8 p-0-16 p-12-0 c-171A1D relative"
          @click="handlerDetail(item)"
          v-for="item in computedEvaluationList"
          :key="item.deptDingId"
        >
          <div
            v-show="
              item.deptType === 2 &&
              (curIsAdmin || curIsCampusHeadmaster || curIsMeTeacher)
            "
            @click.stop="$emit('evaluation', item)"
            class="absolute top-0 right-0 font-28 c-006AFE p-12-0 p-0-12"
          >
            <i class="iconfont mr-4 font-34">&#xe776;</i>考评
          </div>
          <p
            class="font-30 text-bold pb-12 break-all"
            :class="[item.deptType === 2 ? 'pr-64' : '']"
            >{{ item.deptName }}</p
          >
          <div class="pt-1 fb fb-cross-center fb-main-between">
            <div class="item-flex-1 text-center p-0-5">
              <p class="font-30 ff-medium pb-2 text-bold-600 break-all">
                {{ +item.totalPraiseScore > 0 ? '+' : ''
                }}{{ item.totalPraiseScore }}
              </p>
              <p class="font-24 c-171A1D-60 ff-regular">表扬</p>
            </div>
            <div class="item-flex-1 text-center">
              <p class="font-30 ff-medium pb-2 text-bold-600 break-all">
                {{ item.totalNeedImproveScore }}
              </p>
              <p class="font-24 c-171A1D-60 ff-regular">待改进</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="bg-F6F6F6 p-0-16 hidden" key="single">
        <div class="pt-20 fb fb-cross-center">
          <template v-for="item in classTypeList">
            <div
              :key="item.id"
              class="list-item title font-28 fb fb-cross-center fb-main-center"
            >
              <template v-if="item.id > 0">
                <div
                  class="pr-4"
                  :class="{ 'c-006AFE': curSortMap.id === item.id }"
                >
                  {{ item.label }}
                </div>
                <div class="fb fb-cross-center fb-main-center">
                  <div>
                    <p
                      class="triangle up mb-2"
                      @click="handlerSort(item, 'up')"
                      :class="{
                        active:
                          curSortMap.id === item.id && curSortMap.order === 'up'
                      }"
                    >
                    </p>
                    <p
                      class="triangle down"
                      @click="handlerSort(item, 'down')"
                      :class="{
                        active:
                          curSortMap.id === item.id &&
                          curSortMap.order === 'down'
                      }"
                    >
                    </p>
                  </div>
                </div>
              </template>
              <template v-else>
                {{ item.label }}
              </template>
            </div>
          </template>
        </div>
        <div
          class="single-list bg-FFFFFF fb fb-cross-center bd-radio-8 mb-8"
          v-for="(item, index) in computedEvaluationList"
          :key="`${item.studentDingId}-${index}`"
          @click="handlerDetail(item)"
        >
          <div class="list-item ff-medium text-bold-500 font-30">
            {{ formatName(item.studentName) }}
          </div>
          <div class="list-item fm-helvetica text-bold font-30">
            {{ +item.totalPraiseScore > 0 ? '+' : ''
            }}{{ item.totalPraiseScore }}
          </div>
          <div class="list-item fm-helvetica text-bold font-30">
            {{ item.totalNeedImproveScore }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from '@/mixin'
const NAME_LIMIT = 4 // 姓名长度限制

const EVALUATION_CLASS_TYPE_LIST = [
  {
    id: -1,
    label: '姓名'
  },
  {
    id: 1,
    label: '表扬',
    sortKey: 'totalPraiseScore'
  },
  {
    id: 2,
    label: '待改进',
    sortKey: 'totalNeedImproveScore'
  }
]
export default {
  mixins: [mixin],
  name: 'evaluation',
  props: {
    // 组件的类型  1-2 类型样式一致
    type: {
      type: [Number, String],
      default: 3
    },
    // 标题
    title: {
      type: String
    },
    evaluationList: {
      type: [Array, String],
      default: null
    }
  },
  data() {
    return {
      curSortMap: {},
      classTypeList: EVALUATION_CLASS_TYPE_LIST
    }
  },
  computed: {
    evaluationTitle() {
      return this.title
    },
    totalEvaluationMap() {
      let _totalPraiseScore = 0
      let _totalNeedImproveScore = 0
      this.evaluationList.forEach(item => {
        _totalPraiseScore += Number(item.totalPraiseScore || 0)
        _totalNeedImproveScore += Number(item.totalNeedImproveScore || 0)
      })
      return {
        totalPraiseScore: _totalPraiseScore,
        totalNeedImproveScore: _totalNeedImproveScore
      }
    },
    computedEvaluationList() {
      if (+this.type === 1 || +this.type === 2) {
        return this.evaluationList
      }
      if (this.curSortMap.id) {
        let _classList = JSON.parse(JSON.stringify(this.evaluationList))

        _classList.sort(
          this.sortData(this.curSortMap.sortKey, this.curSortMap.order)
        )
        return _classList
      }
      return this.evaluationList
    }
  },
  methods: {
    // 对长度大于限制的姓名做处理
    formatName(userName) {
      if (!userName) {
        return ''
      }
      userName = String(userName)
      if (userName.length > NAME_LIMIT) {
        return `${userName.slice(0, 2)}...${userName.slice(-1)}`
      }
      return userName
    },
    sortData(key, order = 'down') {
      return (a, b) => {
        if (order === 'down') {
          return b[key] - a[key]
        }
        return a[key] - b[key]
      }
    },
    handlerSort(item, order) {
      if (this.curSortMap.id === item.id && this.curSortMap.order === order) {
        this.curSortMap = {}
        return
      }
      this.curSortMap = {
        ...item,
        order
      }
    },
    handlerDetail(item) {
      this.$emit('detail', item)
    },
    handleToRecords(type) {
      this.$emit('click-summary', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.dot {
  display: block;
  width: 4px;
  height: 8px;
  flex-shrink: 0;
  margin-right: 4px;
}
.list-card {
  margin: 20px 0;
}
.break-all {
  word-break: break-all;
}

.fm-helvetica {
  font-family: Helvetica, Helvetica-Bold;
}

.list-item {
  flex: 1;
  width: 33.33333333%;
  text-align: center;
  padding: 12px 4px;
  font-size: 14px;
  &.title {
    padding: 0 4px 12px;
  }
}

.triangle {
  $triangle_width: 4px;
  width: 0;
  height: 0;
  border-right: $triangle_width solid transparent;
  border-left: $triangle_width solid transparent;
  &.up {
    border-bottom: $triangle_width solid rgba(17, 31, 44, 0.4);
    &.active {
      border-bottom: $triangle_width solid #006afe;
    }
  }
  &.down {
    border-top: $triangle_width solid rgba(17, 31, 44, 0.4);
    &.active {
      border-top: $triangle_width solid #006afe;
    }
  }
}
</style>
